module.exports = __webpack_public_path__ + "static/media/iphone demo.1c3e83e2.png";